import { RETRY_FAILED_SERVICES } from '../constants/ActionTypes';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import size from 'lodash/size';
import invoke from 'lodash/invoke';
import map from 'lodash/map';
import { loadFonts } from './theme';

const serviceMap = {
    getFontList: loadFonts
};

const getFailedServices = serviceType => {
    return reduce(
        serviceType,
        (failedServices, attributes, serviceName) => {
            const hasServiceFailed = get(attributes, 'isHealthy') === false;
            if (hasServiceFailed) {
                const options = get(attributes, 'options');
                const mappedAction = () => invoke(serviceMap, [serviceName], options);
                return [...failedServices, mappedAction];
            }

            return failedServices;
        },
        []
    );
};

export const hasFailedServices = (type, state) => {
    const serviceHealth = get(state, 'app.serviceHealth');
    return !!size(getFailedServices(serviceHealth[type]));
};

export const retryFailedServices = type => (dispatch, getState) => {
    const serviceHealth = get(getState(), 'app.serviceHealth');
    const failedServices = getFailedServices(serviceHealth[type]);

    dispatch({ type: RETRY_FAILED_SERVICES });
    const failedServicesPromises = map(failedServices, service => dispatch(service()));
    return Promise.all(failedServicesPromises);
};



// WEBPACK FOOTER //
// ./src/actions/retry.js